<template>
  <div>
    <!-- 系统功能 -->
    <div class="fm-aligncenter fm-rela price-out">
      <div class="content fm-center">
        <div class="fm-flex">
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
          <span class="content-title">系统功能及定价</span>
          <el-image
            @dragstart.prevent
            class="content-titledesc"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/titledesc.png"
            fit="contain"
          ></el-image>
        </div>
        <div class="price-div">
          <el-row>
            <el-col
              :span="8"
              :offset="7"
              class="price-content fm-center"
              style="line-height: unset"
            >
              <p class="fm-maintitle" style="font-weight: bold">智数云ERP</p>
              <el-link class="fm-mt-5" type="success" :underline="false">
                当前产品
              </el-link>
            </el-col>
            <el-col
              :span="9"
              class="price-content fm-center"
              style="line-height: unset"
            >
              <p class="fm-maintitle" style="font-weight: bold">GO家居</p>
              <el-link
                class="fm-mt-5"
                type="primary"
                :underline="false"
                href="https://fmerp.intelure.com/"
              >
                点击跳转至GO家居官网
                <i class="el-icon el-icon-d-arrow-right"></i>
              </el-link>
            </el-col>
          </el-row>
        </div>
        <div class="price-div">
          <div class="price-detail">
            <div style="max-height: 60vh; overflow-y: auto">
              <el-collapse :value="priceList.map((d) => d.title.text)">
                <el-collapse-item
                  :name="priceItem.title.text"
                  v-for="(priceItem, priceIndex) in priceList"
                  :key="priceIndex"
                >
                  <template slot="title">
                    <el-row
                      class="fm-mb-5"
                      style="width: 100%; padding: 10px 0"
                    >
                      <el-col :span="6" class="fm-pl-5">
                        <div class="fm-flex">
                          <el-image
                            @dragstart.prevent
                            class="price-img"
                            :src="priceItem.title.src"
                            fit="contain"
                            v-if="priceItem.title.src"
                          ></el-image>
                          <p class="price-title">
                            · {{ priceItem.title.text }}
                          </p>
                        </div>
                      </el-col>
                      <el-col
                        :span="9"
                        class="price-content fm-center"
                        style="font-weight: bold; line-height: 60px"
                        >{{ priceItem.title.erp }}</el-col
                      >
                      <el-col
                        :span="9"
                        class="price-content fm-center"
                        style="font-weight: bold; line-height: 60px"
                        >{{ priceItem.title.go }}</el-col
                      >
                    </el-row>
                  </template>

                  <el-row
                    class="fm-mb-5 price-row"
                    v-for="(item, index) in priceItem.item"
                    :key="index"
                  >
                    <el-col :span="6" class="fm-pl-20">
                      <p style="font-size: 16px">{{ item.text }}</p>
                    </el-col>
                    <el-col :span="9" class="fm-center">
                      <div class="fm-flex fm-center">
                        <i
                          v-fmtype="'success'"
                          class="el-icon el-icon-success price-content"
                          v-if="item.erp.showSuccessIcon"
                        ></i>
                        <i
                          v-fmtype="'info'"
                          class="el-icon el-icon-close price-content"
                          style="font-weight: bold"
                          v-if="item.erp.showCloseIcon"
                        ></i>
                        <p
                          v-fmtype="item.erp.text.fmtype"
                          v-if="item.erp.text && item.erp.text.label"
                        >
                          {{ item.erp.text.label }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :span="9" class="fm-center">
                      <div class="fm-flex fm-center">
                        <i
                          v-fmtype="'success'"
                          class="el-icon el-icon-success price-content"
                          v-if="item.go.showSuccessIcon"
                        ></i>
                        <i
                          v-fmtype="'info'"
                          class="el-icon el-icon-close price-content"
                          style="font-weight: bold"
                          v-if="item.go.showCloseIcon"
                        ></i>
                        <p
                          v-fmtype="item.go.text.fmtype"
                          v-if="item.go.text && item.go.text.label"
                        >
                          {{ item.go.text.label }}
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </div>
            <el-row
              style="
                width: 100%;
                padding-top: 10px;
                border-top: 1px solid var(--fm-border-color);
              "
            >
              <el-col :span="6" class="fm-pl-40">
                <p class="price-title" style="margin-left: 0">定价</p>
              </el-col>
              <el-col
                :span="9"
                class="price-content fm-center"
                style="font-weight: bold; line-height: 60px"
              >
                <p style="color: #1252d9; font-weight: bold">￥598/年</p>
              </el-col>
              <el-col
                :span="9"
                class="price-content fm-center"
                style="font-weight: bold; line-height: 60px"
              >
                <p style="color: #1252d9; font-weight: bold">￥698/年</p>
              </el-col>
            </el-row>
            <el-row class="fm-mb-5" style="width: 100%; padding-top: 10px">
              <el-col :span="24" class="fm-pl-40">
                <p style="font-size: 14px; line-height: 30px">
                  <i class="el-icon el-icon-info"></i>
                  右侧所列价格均为5用户版本，若用户数量超过5人，则每增加一人需额外支付100元/年
                </p>
                <p style="font-size: 14px; line-height: 30px">
                  <i class="el-icon el-icon-info"></i>
                  更多定制需求，请联系我们
                </p>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-row class="price-concat-div fm-center">
          <div class="fm-flex price-concat-info-div">
            <div>
              <p class="price-concat-info-text">
                微信扫码联系专属客服了解更多产品功能及信息
              </p>
            </div>
            <el-image
              @dragstart.prevent
              style="height: 150px; width: 150px; margin-left: 100px"
              :src="require('@/assets/images/qywxqrcode.png')"
              fit="contain"
            ></el-image>
          </div>
          <el-image
            @dragstart.prevent
            class="price-concat-img"
            src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-concatbg.png"
            fit="contain"
          ></el-image>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebLoginPrice",

  data() {
    return {
      priceList: [
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-system.png",
            text: "系统管理",
            erp: "4 项",
            go: "4 项",
          },
          item: [
            {
              text: "用户管理",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "组织结构",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "自定义权限",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "系统参数设置",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-data.png",
            text: "主数据",
            erp: "2 项",
            go: "4 项",
          },
          item: [
            {
              text: "客户",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "供应商",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "资金账户",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-sale.png",
            text: "销售模块",
            erp: "1 项",
            go: "4 项",
          },
          item: [
            {
              text: "预收单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "销售单",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "销售退货单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "资金账户",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-purchase.png",
            text: "采购模块",
            erp: "1 项",
            go: "3 项",
          },
          item: [
            {
              text: "预付单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "采购单",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "采购退货单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-inout.png",
            text: "库存模块",
            erp: "0 项",
            go: "2 项",
          },
          item: [
            {
              text: "出库单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "入库单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-fund.png",
            text: "资金模块",
            erp: "0 项",
            go: "3 项",
          },
          item: [
            {
              text: "收款单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "付款单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "资金互转单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-revenue.png",
            text: "费用模块",
            erp: "0 项",
            go: "2 项",
          },
          item: [
            {
              text: "其他收入单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "费用支出单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-report.png",
            text: "报表",
            erp: "3 项",
            go: "7 项",
          },
          item: [
            {
              text: "销售/回款业绩",
              erp: {
                showSuccessIcon: false,
                text: {
                  label: "仅支持销售业绩统计",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "商品销售/采购统计",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "配送费统计",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "供应商采购统计",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
            {
              text: "规格库存明细统计",
              erp: {
                showSuccessIcon: true,
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
        {
          title: {
            src: "https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/price-icon-dingzhi.png",
            text: "定制模块",
            erp: "0 项",
            go: "1 项",
          },
          item: [
            {
              text: "定制单",
              erp: {
                showSuccessIcon: false,
                showCloseIcon: true,
                text: {
                  label: "不支持",
                  fmtype: "info",
                },
              },
              go: {
                showSuccessIcon: true,
              },
            },
          ],
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" >
.content {
  position: relative;
  font-size: 16px;
  width: 900px;

  &-divl {
    position: relative;
    width: 600px;
    z-index: 1;
    left: 10px;
    font-size: 18px;
    > * {
      padding-bottom: 8px;
    }
  }

  &-divr {
    position: relative;
    width: 650px;
    z-index: 1;
    left: 480px;
    font-size: 18px;
    margin-bottom: 20px;

    > * {
      padding-bottom: 8px;
    }
  }

  &-title {
    font-size: 42px;
    font-weight: bold;
  }

  &-titledesc {
    width: 53px;
    height: 38px;
    margin: 75px 30px;
  }

  &-subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
    color: #195bda;
    margin-bottom: 20px;
  }

  &-content {
    font-size: 20px;
    line-height: 40px;
    margin-bottom: 20px;
  }

  &-imgr {
    width: 650px;
    height: 441px;
  }
  &-imgl {
    width: 650px;
    height: 441px;
  }
}

.price {
  &-out {
    background-color: #ebf4ff;
    padding-top: 70px;
  }

  &-img {
    width: 30px;
    height: 30px;
    line-height: 60px;
  }

  &-title {
    font-size: 20px;
    font-weight: bold;
    color: #195bda;
    margin-left: 5px;
    line-height: 60px;
  }

  &-content {
    font-size: 18px;
    line-height: 1.3em;
  }

  &-div {
    width: 100%;
    margin-bottom: 20px;
  }

  &-detail {
    width: 100%;
    padding: 20px 10px;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px 0px #b3d5ff;
  }

  &-row {
    cursor: pointer;
    width: 100%;
    padding: 10px 0 10px 25px;
    &:hover {
      background-color: #f5f5f5;
    }
  }

  &-concat {
    &-div {
      width: 1100px;
      height: 231px;
    }
    &-info {
      &-div {
        z-index: 2;
        position: relative;
      }
      &-text {
        font-size: 22px;
        line-height: 50px;
      }
    }
    &-img {
      width: 1100px;
      height: 231px;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
    }
  }
}

/* 确保你的自定义样式在全局生效或使用深度选择器（如果是在 scoped CSS 中） */
.price-detail .el-collapse-item__header {
  flex-direction: row-reverse; /* 反转箭头和标题的顺序 */
}

/* 覆盖默认箭头的样式，确保其正确显示 */
.price-detail .el-collapse-item__arrow {
  margin-right: 0;
  margin-left: 8px; /* 根据需要调整 */
}

.price-detail .el-collapse-item__content {
  padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/login/LoginPrice.vue